<template>
  <!-- App -->
  <!-- <f7-page class="" id="contacts"> -->
  <div class="page rowBackgroundHomepage">
    <!--bottom-toolbar></bottom-toolbar-->
    <div v-if="isSmartphoneOS">
      <f7-searchbar class="search" v-if="isSmartphoneOS"
        style="position:absolute;top:44px;width:100%;z-index:10;"
        id="searchBankAccount"
        :cancel-link="$t('common.cncl')"
        search-list="#bank-list"
        :placeholder="$t('bank_accounts.srch_in_accnts')"
        @searchbar:search="onSearch"
        @searchbar:clear="onClear">
      </f7-searchbar>
    </div>
    <div class="showSmallScreenOnly">
      <f7-fab class="leftfav4 button-fab bottomButton" @click="openFormsPage()"
        :disabled="$engine.rights.rightIs('bank_account_ajouter', false)">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 button-fab bottomButton" @click="openFormsImportPage()"
        :disabled="$engine.rights.rightIs('bank_account_ajouter', false)">
        <f7-icon f7="list_bullet"></f7-icon>
        <span class="showLargeScreenOnly fab-label">{{ $t('bank_accounts.add_bank_account') }}</span>
      </f7-fab>
      <f7-fab class="leftfav2 button-fab bottomButton" @click="openFormListStatement()">
        <f7-icon f7="money_euro"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav button-fab bottomButton" @click="extractCSV()">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content">
      <div class="layoutTop" v-if="!isSmartphoneOS"></div>
      <div style="height:88px;" v-else></div>
      <div class="listPage">
        <b-row class="form-group justify-content-start showLargeScreenOnly">
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack"
              :disabled="$engine.rights.rightIs('bank_account_ajouter', false)"
              @click="openFormsPage()">
              <f7-icon f7="add"></f7-icon>
              <span>{{ $t('common.add_label') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack"
              :disabled="$engine.rights.rightIs('bank_account_ajouter', false)"
              @click="openFormsImportPage()">
              <f7-icon f7="list_bullet"></f7-icon>
              <span>{{ $t('common.imprt') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="2">
            <button class="button-action milkyBlockBlack"
              @click="openFormListStatement()">
              <f7-icon f7="money_euro"></f7-icon>
              <span>{{ $t('bank_accounts.view_statements') }}</span>
            </button>
          </b-col>
          <b-col sm="2">
            <button class="button-action milkyBlockBlack"
              @click="extractCSV()">
              <f7-icon f7="document_text"></f7-icon>
              <span>{{ $t('common.extract') }}</span>
            </button>
          </b-col>
          <b-col sm="2">
            <button class="button-action milkyBlockBlack"
              @click="linkRapprochement()">
              <f7-icon f7="data"></f7-icon>
              <span>{{ $t('bank_accounts.rcncltn') }}</span>
              <span v-if="nbOperations" class="new-badge badge-danger">{{nbOperations}}</span>
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div id="containerCSV" style="display:none;"></div>
            <f7-searchbar class="search" v-if="!isSmartphoneOS"
              id="searchBankAccount"
              :cancel-link="$t('common.cncl')"
              search-list="#bank-list"
              :placeholder="$t('bank_accounts.srch_in_accnts')"
              @searchbar:search="onSearch"
              @searchbar:clear="onClear">
            </f7-searchbar>
          </b-col>
        </b-row>
        <div class="layoutSubtitle"/>

        <div class="itemList">
          <!--<f7-list class="searchbar-found" id="search-list">-->
          <spinner v-if="activateSpinner"></spinner>
          <cm-bank-accounts-list v-else :bankAccounts="bankAccounts" :filterBy="filterBy">
          </cm-bank-accounts-list>
          <cm-pagination
            :firstIndex="paginationObject.firstIndex"
            :maxResultsByPage="paginationObject.maxResults"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh">
          </cm-pagination>
          <!--</f7-list>-->
          <f7-list class="searchbar-not-found">
            <f7-list-item title="Nothing found"></f7-list-item>
          </f7-list>
        </div>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
import moment from 'moment'

import pagination from '@/components/common/pagination.vue'
import spinner from '@/components/common/spinner.vue'

import BankAccountsList from './CMBankAccountsPage/CMBankAccountsList.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'BankAccounts',
  components: {
    'cm-bank-accounts-list': BankAccountsList,
    'cm-pagination': pagination,
    'spinner': spinner
  },
  data () {
    return {
      activateSpinner: false,
      bankAccounts: [],
      filterBy: '',
      service: '',
      paginationObject: {},
      nbOperations: 0
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$i18n.t('Webheader.my_bank_accounts'),
      returnUrl: 'none'
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-bank-accounts'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$off('refresh-bank-accounts')
    this.$bus.on('refresh-bank-accounts', (index = 1) => {
      this.getBankAccounts(index)
    })
    this.getBankAccounts()
    this.service = this.$engine.user.currentService.name
  },
  methods: {
    getBankAccounts (index = 1) {
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.paginationObject.firstIndex = index
      let params = {
        // firstIndex: this.paginationObject.firstIndex,
        // maxResults: this.paginationObject.maxResults,
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.activateSpinner = true
      this.$engine.bankAccounts.getParams(params).then(response => {
        this.organiserResponse(response)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    organiserResponse (response) {
      var bankAccountsList = []
      let bankAccountsReturn = response.data.bankAccounts
      let nbElement = 0
      this.nbOperations = bankAccountsReturn.reduce((acc, account) => [...acc, ...account.needReconciliation.operations], []).length
      this.paginationObject.nbResults = 0
      for (var j = 0; j < bankAccountsReturn.length; j++) {
        if (bankAccountsReturn[j].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            this.paginationObject.nbResults++
            bankAccountsList.push(bankAccountsReturn[j])
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      this.bankAccounts = bankAccountsList
      // this.$bus.on => src\components\common\pagination.vue
      this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      this.activateSpinner = false
    },
    onSearch (query, found) {
      this.filterBy = query
      this.getBankAccounts()
    },
    onClear () {
      this.filterBy = ''
    },
    openFormsPage () {
      loadPage(this, {url: '/bankAccounts/create/'})
    },
    openFormsImportPage () {
      loadPage(this, {url: '/bankAccounts/import/'})
    },
    openFormListStatement () {
      let that = this
      let bankAccounts = that.$engine.bankAccounts.get()
      // let bankAccountsDone = 0
      for (var i in bankAccounts) {
        that.$engine.bankAccounts.getOperationStatements(bankAccounts[i].iban).then(response => {
          if (response.status === 200) {
            let innerBankAccounts = that.$engine.bankAccounts.get()
            for (var innerIndex in innerBankAccounts) {
              if (innerBankAccounts[innerIndex].iban === response.data.iban) {
                innerBankAccounts[innerIndex].balances = response.data.receivedTransfers
              }
              if (innerIndex + 1 === innerBankAccounts.length) {
                that.$engine.bankAccounts.set(bankAccounts)
              }
            }
          }
        })
      }
      // let dummycounter = 0
      // while (bankAccountsDone !== bankAccounts.length) {
      //   if (dummycounter < 10000) {
      //     console.log('I\'m waiting ! bankAccountsDone = ' + bankAccountsDone)
      //     dummycounter++
      //   } else {
      //     break
      //   }
      // }
      that.$engine.bankAccounts.setImportReport('')
      that.$engine.bankAccounts.setIbanStatment('')
      loadPage(that, {url: '/bankAccounts/listStatement/'})
    },
    extractCSV () {
      let params = {
        firstIndex: 1,
        maxResults: this.paginationObject.nbResultsTotal,
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.$engine.bankAccounts.getParams(params).then(response => {
        let firstLine = 'id;name;Iban\r\n'
        let lines = ''
        let bankAccounts = response.data.bankAccounts
        for (var account in bankAccounts) {
          lines += bankAccounts[account].id + ';' + bankAccounts[account].name + ';' +
          bankAccounts[account].iban + '\r\n'
        }

        let data = firstLine + lines
        let today = moment()
        // encode 64 résoud le pb du retour à la ligne sur Firefox.
        var linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(data)

        const downloadLink = document.createElement('a')
        var fileName = ''
        if (this.service === 'Direct Debit') {
          fileName = 'bankAccountModularLoan' + today.unix() + '.csv'
        } else if (this.service === 'Direct Payments') {
          fileName = 'bankAccountDirectPayments' + today.unix() + '.csv'
        } else {
          fileName = 'bankAccountRequestToPay' + today.unix() + '.csv'
        }

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    linkRapprochement () {
      loadPage(this, {url: '/bankAccounts/rapprochement'})
    }
  }
}
</script>


<style scoped>
/* .AddBankAccount {
	width: 98%;
} */
/* .EditBankAccount {
	width: 98%;
} */
@media (min-width: 767px) and (max-width: 996px) {
  .search {
    margin-top: 35px;
  }
}
@media (max-width: 767px) {
  .toolbarPageBottomBlank {
    height: 175px;
  }
}

.new-badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// CMBankAccountsPage.vue?b30bec68